import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import MultiSelect, { MultiSelectProps } from 'components/MultiSelect';

import { PoiSelect_data$key } from '__generated__/PoiSelect_data.graphql';

type Props = Omit<MultiSelectProps, 'options'> & {
  data: PoiSelect_data$key;
};

const PoiSelect: FC<Props> = ({ data, ...props }) => {
  const { pois } = useFragment(
    graphql`
      fragment PoiSelect_data on Query {
        pois(first: 2147483647) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
    data
  );

  return (
    <MultiSelect
      {...props}
      options={pois?.edges.map(({ node }) => node) ?? []}
    />
  );
};

export default PoiSelect;
